import {
	buildCriterionExpression,
	buildFieldSortCriterion,
	buildRelevanceSortCriterion,
	SortCriterion,
	SortOrder,
} from "@coveo/headless";
import {
	CoveoHeadlessSortCriteria,
	CoveoHeadlessSortBy,
	SortByDictionary,
} from "../types/coveo-headless-types";

const setDefaultSort = (
	sortCriteria: CoveoHeadlessSortCriteria[],
	criteriaDictionary: SortByDictionary[]
) => {
	let nameInCriteriaDictionary: SortByDictionary | undefined;
	// grab criteria string to use as default sortCriteria parameter for searchParameterManager
	const foundActiveSortCriteria = sortCriteria.find((item) => item.isActive === true);
	if (foundActiveSortCriteria) {
		let initialCriterion: SortCriterion | SortCriterion[];
		if (foundActiveSortCriteria.criteria === CoveoHeadlessSortBy.Relevancy) {
			initialCriterion = buildRelevanceSortCriterion();
		} else {
			// if initial sort criteria is a field (i.e. @publishdate descending)
			// split the string and remove the @ from the field
			const initialCriteria: string[] | undefined = foundActiveSortCriteria?.criteria.split(" ");
			const criterion = initialCriteria?.length ? initialCriteria[0].replace(/@/, "") : "";
			initialCriterion = buildFieldSortCriterion(
				criterion,
				initialCriteria !== undefined
					? initialCriteria[1] === "descending"
						? SortOrder.Descending
						: SortOrder.Ascending
					: SortOrder.Ascending
			);
		}
		// build a SortCriterion to use for mobile sort by
		nameInCriteriaDictionary = criteriaDictionary.find((c) => {
			return buildCriterionExpression(initialCriterion) === buildCriterionExpression(c.criterion);
		});
	}
	const criteria = foundActiveSortCriteria
		? foundActiveSortCriteria.criteria
		: CoveoHeadlessSortBy.Relevancy;
	const sortName = nameInCriteriaDictionary ? nameInCriteriaDictionary.name : "Relevancy";
	return { criteria, sortName };
};

export default setDefaultSort;
